import { Model } from './model';
import { flattenObject } from '../utils/utils';

export class Paginated extends Model {
  data: Array<any>;
  page: number;
  size: number;
  total: number;
  toRawValue() {
    return this.data.map(r => flattenObject(r));
  }
  add(obj): void {
    this.data.push(obj);
  }
}
